// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"b63d1816","152":"a56850d0","221":"ef3395d3","328":"0a31a4ff","417":"313c2eaf","425":"122a9013","551":"0483da42","691":"3b73778b","840":"dbc42ff9","861":"75f41219","978":"12a03a14"}[chunkId] + ".chunk.js";
};